import React from 'react';
import { Box, TextField } from '@mui/material';
import { Label16Regular, Label16SemiBold } from 'components';

interface DimensionTitlesInputProps {
    value: string;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const DimensionTitlesInput = ({ value, onChange }: DimensionTitlesInputProps) => (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
        <Label16SemiBold>Dimension Column Titles</Label16SemiBold>
        <div>
            <Label16Regular>Copy and paste your titles from Excel OR</Label16Regular>
            <Label16Regular>manually type your data - adding a semi-colon between each title.</Label16Regular>
        </div>
        <Label16Regular sx={{ color: '#054254', fontStyle: 'italic' }}>
            *you can also add this information in the next step.
        </Label16Regular>
        <TextField
            name="dimensionColumnTitles"
            value={value}
            onChange={onChange}
            fullWidth
            multiline
            rows={4}
            variant="outlined"
            sx={{
                width: '470px',
                '& .MuiInputBase-root textarea': {
                    resize: 'vertical',
                    overflow: 'auto',
                },
            }}
            inputProps={{ 'aria-label': 'Dimension column titles' }}
        />
    </Box>
);